<main class="address-information" [formGroup]="addressForm">
  <section class="form-header">
    <p>{{ formNumber }}.</p>
    <aside>
      @if (canBeDeleted) {
        <mat-icon (click)="onDelete()">delete</mat-icon>
      }
    </aside>
  </section>
  <section class="address-row">
    <fieldset class="inputAndErrorFieldSet">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ eventTitles.LOCATION_NAME }}</mat-label>
        <input
          type="text"
          matInput
          [matAutocomplete]="auto"
          placeholder="Add location name"
          formControlName="locationName"
        />

        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayLocation"
          (optionSelected)="onLocationSelected($event.option.value)"
        >
          @for (location of filteredLocations; track location) {
            <mat-option [value]="location">
              {{ location.locationName }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      @if (
        addressForm.get("locationName")?.hasError("required") &&
        addressForm.get("locationName")?.touched
      ) {
        <mat-error>
          {{ eventMessages.LOCATION_REQUIRED }}
        </mat-error>
      }
    </fieldset>
  </section>

  <section class="address-row">
    <fieldset class="inputAndErrorFieldSet">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ eventTitles.ADDRESS_ONE }}</mat-label>
        <input
          matInput
          placeholder="Add address line 1 (Optional)"
          formControlName="addressLineOne"
        />
      </mat-form-field>
    </fieldset>
    <fieldset class="inputAndErrorFieldSet">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ eventTitles.ADDRESS_TWO }}</mat-label>
        <input
          matInput
          placeholder="Add address line 2"
          formControlName="addressLineTwo"
        />
      </mat-form-field>
      @if (
        addressForm.get("addressLineTwo")?.hasError("required") &&
        addressForm.get("addressLineTwo")?.touched
      ) {
        <mat-error>
          {{ eventMessages.ADDRESS_LINE_TWO_REQUIRED }}
        </mat-error>
      }
    </fieldset>
  </section>

  <section class="address-row">
    <fieldset class="inputAndErrorFieldSet">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ eventTitles.SUBURB }}</mat-label>
        <input matInput placeholder="Add suburb" formControlName="suburb" />
      </mat-form-field>
      @if (
        addressForm.get("suburb")?.hasError("required") &&
        addressForm.get("suburb")?.touched
      ) {
        <mat-error>
          {{ eventMessages.SUBURB_REQUIRED }}
        </mat-error>
      }
    </fieldset>
    <fieldset class="inputAndErrorFieldSet">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ eventTitles.CITY }}</mat-label>
        <input matInput placeholder="Add city" formControlName="city" />
      </mat-form-field>
      @if (
        addressForm.get("city")?.hasError("required") &&
        addressForm.get("city")?.touched
      ) {
        <mat-error>
          {{ eventMessages.CITY_REQUIRED }}
        </mat-error>
      }
    </fieldset>
    <fieldset class="inputAndErrorFieldSet">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ eventTitles.POSTAL_CODE }}</mat-label>
        <input matInput placeholder="Add postal code" formControlName="code" />
      </mat-form-field>
      @if (
        addressForm.get("code")?.hasError("required") &&
        addressForm.get("code")?.touched
      ) {
        <mat-error>
          {{ eventMessages.POSTAL_CODE_REQUIRED }}
        </mat-error>
      }
      @if (
        addressForm.get("code")?.hasError("pattern") &&
        addressForm.get("code")?.touched
      ) {
        <mat-error>
          {{ eventMessages.INVALID_CODE }}
        </mat-error>
      }
    </fieldset>
  </section>
</main>
